// extracted by mini-css-extract-plugin
export var answerStyle = "FAQ-module--answerStyle--e74e6";
export var highlighted = "FAQ-module--highlighted--3576a";
export var questionStyle = "FAQ-module--questionStyle--266f6";
export var search = "FAQ-module--search--d96e2";